import { TextInput, BooleanInput } from "ra-ui-materialui";

const NavigationForm = () => (
  <>
    <BooleanInput source="is_top_menu" />
    <TextInput
      source="title"
      fullWidth
    />
    <TextInput
      source="title_en"
      fullWidth
    />
    <TextInput
      source="route"
      fullWidth
    />
  </>
);

export default NavigationForm;
